module.exports = require('../commonjs/unicode.js')